module.exports = __webpack_public_path__ + "img/gzxed.41e987e2.png";